import {useOpenModal} from '@/components/Modal/index.mjs'
import SelectMapVerDialog from '@/pages/MainPage/dialogs/SelectMapVerDialog.jsx'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const openModal = useOpenModal()
    const map = useMapContext()

    if (! map.permission.has('write')) {
        return null
    }

    const onClick = async () => {
        const data = await openModal(
            <SelectMapVerDialog id={map.dp.pkid} />
        )

        if (! data) {
            return
        }

        map.setContent(data.dpContent)
    }

    return {
        key: 'import-snapshot',
        label: '导入发布版本',
        onClick,
    }
}
